import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import styles from "./BotomSheet.module.scss";
import SheetLine from "../../assets/icons/sheet-line.svg?react";
import { createPortal } from "react-dom";

interface BottomSheetProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  noPadding?: boolean;
  maxHeight?: string; // e.g. "80dvh", "50vh", "400px"
}

const BottomSheet: React.FC<BottomSheetProps> = ({
  open,
  onClose,
  children,
  noPadding = false,
  maxHeight,
}) => {
  const { backdrop, sheet, content, sheetLine, noPaddingClass, scrollable } =
    styles;

  return createPortal(
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            className={backdrop}
            onClick={onClose}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          />

          <motion.div
            className={`${sheet} ${noPadding ? noPaddingClass : ""}`}
            style={maxHeight ? { maxHeight } : undefined}
            initial={{ y: "100%" }}
            animate={{ y: 0 }}
            exit={{ y: "100%" }}
            transition={{ type: "tween", duration: 0.32, ease: [0.32, 0.72, 0, 1] }}
          >
            <button onClick={onClose} className={sheetLine}>
              <SheetLine />
            </button>
            <div className={`${content} ${maxHeight ? scrollable : ""}`}>
              {children}
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>,
    document.body,
  );
};

export default BottomSheet;
